export const upload = async (presignedUrl: string, fileObject: File, mimeType: string): Promise<string | null> => {
	try {
			const response = await fetch(
					presignedUrl,
					{
							method: 'PUT',
							body: fileObject,
							headers: {
									'Content-Type': mimeType
							}
					}
			);

			if (!response.ok) {
					return null;
			}

			// S3のオブジェクトキー（ファイルパス）をプリサインドURLから抽出
			const uploadedFilePath = presignedUrl.split('?')[0].split('/').slice(3).join('/');
			return uploadedFilePath;
	} catch (error) {
			console.error("Error Upload: ", error);
			return null;
	}
}

export const getPresignedUrl = async (email: string, file1: FileTypeSet, file2: FileTypeSet): Promise<PresignedUrlResponse | null> => {
	const apiUrl = 'https://eysmzsxbsl.execute-api.ap-northeast-1.amazonaws.com';

	if (!file1 && !file2) return null;

	const param: PresignedUrlRequest = {email: email};

	if (file1){
		param.file1 = file1.fileName;
		param.mimeType1 = file1.mimeType;
	};
	if (file2) {
		param.file2 = file2.fileName;
		param.mimeType2 = file2.mimeType;
	};

	const queries = new URLSearchParams();
	Object.entries(param).forEach(([key, value]) => {
			if (value) queries.append(key, value);
	});

	try {
		const res = await fetch(
			`${apiUrl}?${queries}`,
			{
				method: 'GET',
				mode: 'cors',

			}
		)

		if (!res.ok) {
			throw new Error(`Error: ${res.status}`)
		}

		const data: PresignedUrlResponse = await res.json();
		return data;
	} catch (error: any) {
		console.error('Error Presigned URL: ', error);
		return null;
	}
}
